<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 800 600"
        style="enable-background: new 0 0 800 600"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M317.4,277.2c-.7.3-128.7,66.2-133.3,69s-8.6,5.8-8.6,9,2.5,6.2,9.3,7.2,163.9,24.5,163.9,24.5l-31.3-109.7Z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M355.4,403.2s-183.8-35.1-186.7-35.7c-2.9-.5,1.6-6.4,2.2-9.2.6-2.7.1-4.6-1.8-5.4-1.9-.8-5.1,3.1-6.4,4.6s-3.8-1.4-2.7-3.6c1.1-2.3,11.5-7.9,11.5-7.9l143.2-78-17.1-53.5,14.6-4.6,5.3,17.8s30.5-.1,49.4-.4c18.9-.3,20.2-3.5,26.2-6.5s131.9-65.1,131.9-65.1l-2-5.8,19.3-6.9,2.1,6.9,13.5,36.1,1.6-.6,4.6,14.3-19.2,7.3-2-4.9-168.6,194" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M321.4,241.8s43.8-.2,51.2-.2,17.4-3.6,29.1-9,130-62,130-62l2.8,7.1-171,196.8-42.1-132.7Z" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="544.8"
                y1="207.1"
                x2="557"
                y2="236.4" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M575.5,227.8l-5.5-11.1s-4.4-12-13.1-7.9c-8.7,4.1-6.4,10.9-6.4,10.9l8.5,16.4,10.2,19.7,1.3,2.4,53,95.7,11.1-5.8-49.4-100.6-9.7-19.7c18.1-7.9,38.1-12.2,59.1-12.2,82,0,148.4,66.4,148.4,148.4s-66.4,148.4-148.4,148.4-148.4-66.4-148.4-148.4,28.8-101.2,71.9-127.2" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="564"
                y1="199.8"
                x2="568.4"
                y2="212.9" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="522.9 149.9 520.7 144.2 536.5 138.2 541.6 140.8 542.2 143" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M568.7,255.1c-36.6,22.2-61,62.4-61,108.4,0,70,56.7,126.7,126.7,126.7s126.7-56.7,126.7-126.7-56.7-126.7-126.7-126.7-34.3,3.6-49.5,10" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M612.3,334.5c-8.7,6.6-14.4,17.2-14.4,29,0,20.1,16.3,36.4,36.4,36.4s36.4-16.3,36.4-36.4-16.3-36.4-36.4-36.4-6.4.4-9.4,1.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M195.9,332.6c-13.3-15.1-36.3-16.6-51.4-3.3s-16.6,36.3-3.3,51.4c13.3,15.1,36.3,16.6,51.4,3.3,2.4-2.1,6.3-6.4,8-9.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M204.2,363.8c1.7-8.7.3-17.9-4.4-25.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M310.6,394.7c-14.2,67.2-73.8,117.7-145.2,117.7S17,446,17,364s66.4-148.4,148.4-148.4,96.9,26.3,123.5,66.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M293.7,289.4c12.7,21.9,20.1,47.4,20.1,74.5s-.3,11.8-1,17.5" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M289.3,390.6c-12.2,57.2-63.1,100.1-123.9,100.1s-126.7-56.7-126.7-126.7,56.7-126.7,126.7-126.7,81.7,21.8,104.5,55.1" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M274.4,299.3c11.2,18.9,17.7,41,17.7,64.6s-.3,9.6-.8,14.3" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M394.9,438.9c-12.8-11.7-33.7-30.8-37.2-33.6-5-4.1-8.9-9.8-3.6-15.6,5.5-6,11.3-2,12.4-1.1l48.8,50.3" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M411.6,438.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M411.6,438.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M413.8,446.8" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M404.3,447.1s4.8,4.3,8.3,1c.5-.4.6-.6.9-1" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M394.9,438.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M312.4,343.7s2.8-1.7,5.6,1.1,25,22.9,25,22.9" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="313.8"
                y1="358.1"
                x2="338.7"
                y2="384.9" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="403.7 447 386.9 447 386.9 438.9 428.9 438.9 428.9 447 403.7 447" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="319.3 345.6 333.7 345.6 333.7 353.7 327.7 353.7" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M624.4,353.4c0,.1,0,2.4,0,2.4l5.9,11.4s3.8,2.7,5,2.1-1.8-5.6-1.8-5.6c0,0-.9-2.3.6-3,1.5-.6,2.8.8,3.3,1.8.5,1.1,2.6,4.3,2.6,4.3,0,0,3-.7,1.7-4.8-1.3-4.1-5.5-11.7-5.5-11.7l-3-1" />
            <path
                class="cls-10"
                d="M542.5,167.6l.3.9c0,0,0,.1,0,.2l-2,1.6c-.7.5-1,1.4-.7,2.3.2.5.5.9,1,1.1-.2.5-.2,1.1,0,1.5.4,1,1.1,1.5,2,1.4-.6.7-.8,1.7-.5,2.6.3.9,1.1,1.5,2,1.7-.6.7-.8,1.7-.4,2.5s1.1,1.5,2,1.7l-.6.2c-.3.1-.5.5-.4.8.1.3.5.5.8.4l2.5-.9c.4-.1.8.1.9.5s0,.8-.4.9h0s-2.5.9-2.5.9c-.3.1-.5.5-.4.8.1.3.5.5.8.4l2.5-.9h0c.4-.1.8.1.9.4s0,.6-.3.9l-2.2,1.7c-.5.4-.5,1-.4,1.2l.4,1.1,1.1-.4-.4-.9c0,0,0-.1,0-.2l2-1.6c.7-.5,1-1.4.7-2.3-.2-.5-.5-.9-1-1.1.2-.5.2-1.1,0-1.5-.4-1-1.1-1.5-2-1.4.6-.7.8-1.7.5-2.6-.3-.9-1.1-1.5-2-1.7.6-.7.8-1.7.4-2.5s-1.1-1.5-2-1.7l.6-.2c.3-.1.5-.5.4-.8-.1-.3-.5-.5-.8-.4l-2.5.9c-.4.1-.8-.1-.9-.5s0-.8.4-.9h0s2.5-.9,2.5-.9c.3-.1.5-.5.4-.8-.1-.3-.5-.5-.8-.4l-2.5.9h0c-.4.1-.8-.1-.9-.4-.1-.3,0-.6.3-.9l2.2-1.7c.5-.4.5-1,.4-1.2l-.4-1.1-1.1.4ZM543.6,178.7c-.3-.7,0-1.5.8-1.8s1.5.1,1.8.8-.1,1.5-.8,1.8c-.7.3-1.6,0-1.8-.8ZM545.2,182.9c-.3-.7,0-1.5.8-1.8.7-.3,1.5.1,1.8.8s-.1,1.5-.8,1.8-1.5-.1-1.8-.8Z" />
            <circle
                class="fill-none stroke-woom-black stroke-2"
                cx="361.1"
                cy="395.6"
                r="5.4" />
        </g>
        <g class="saddle-normal">
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="310.2"
                y1="209.3"
                x2="297.7"
                y2="169.7" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="298.7"
                y1="212.6"
                x2="286.5"
                y2="172" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M248.6,143.4s81.2,2.6,89.3,2.6,14.3,5.4,12.8,8.7-5.1,2-9.4,1.9-20.5-2.5-35.7,2.4c-15.1,4.9-20.3,11.5-34.8,11s-26.1-7.8-28.8-14c-2.7-6.2-1.3-12.2,6.6-12.6Z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M273.4,170.7s1.4,2.2,5.9,1.6c4.5-.6,20.3-2.3,26-4.6,5.6-2.3,18.3-11.4,18.3-11.4" />
        </g>
        <g class="handlebar-normal">
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M520.7,144.2l-3.9-8.6,1.4-4.9M538.7,133c-3.6,2.2-2.2,5.2-2.2,5.2M530,114.7s0,.6.6,1.5c10.2-2.5,14.8,7.1,14.8,7.1l-1.4,3,3.7,1.6s5.1-4.3,7.3-7.4.8-9.2-3.9-9.8-7.4-.8-14.6-5.5M515.6,87.7c-6,0-10.9,4.9-10.9,10.9s4.9,10.9,10.9,10.9,8.4-2.8,10-6.7c.5-1.3.8-2.7.8-4.2,0-6.1-4.8-10.9-10.8-10.9ZM524.8,104.2s0-1.1,0,4.1,4,6.4,6.3,6.4,5.2-2.4,5.2-5-.4-6.3-1.1-11.7c-.7-5.4-5.8-4.8-9.7-4.8M529.8,92.8c-3.1-4-7.2-2.5-7.2-2.5M549.4,113.3c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7,3.7-1.7,3.7-3.7-1.7-3.7-3.7-3.7Z" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="518.2"
                y1="130.8"
                x2="537.7"
                y2="116.7" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M546,127.6c-3,2.2-5.7,4.2-7.3,5.4" />
        </g>
        <g class="tyres hidden">
            <g>
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="169.4"
                    y1="215.6"
                    x2="169.4"
                    y2="512.3" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="161.6"
                    y="214.4"
                    width="15.6"
                    height="2.4" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="161.6"
                    y="511.1"
                    width="15.6"
                    height="2.4" />
            </g>
            <g>
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="634.5"
                    y1="215.6"
                    x2="634.5"
                    y2="512.3" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="626.7"
                    y="214.4"
                    width="15.6"
                    height="2.4" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="626.7"
                    y="511.1"
                    width="15.6"
                    height="2.4" />
            </g>
        </g>
        <g class="cockpit hidden">
            <g>
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="516.6"
                    y1="98.5"
                    x2="516.6"
                    y2="512.3" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="508.8"
                    y="97.3"
                    width="15.6"
                    height="2.4" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="508.8"
                    y="511.1"
                    width="15.6"
                    height="2.4" />
            </g>
        </g>
        <g class="steering-angle hidden">
            <g>
                <g>
                    <polyline
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        points="492.8 73.5 551.8 199.6 426.7 199.6" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M502.9,199.3c0-19.5,11.6-36.4,28.2-44" />
            </g>
            <g>
                <g
                    id="w2-steering-angle-2"
                    data-name="w2-steering-angle">
                    <g>
                        <line
                            class="h-line-miter fill-none stroke-woom-red stroke-3"
                            x1="554.5"
                            y1="206.3"
                            x2="556.3"
                            y2="209.9" />
                        <line
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            x1="560"
                            y1="217.2"
                            x2="706.7"
                            y2="505" />
                        <polyline
                            class="h-line-miter fill-none stroke-woom-red stroke-3"
                            points="708.6 508.6 710.4 512.2 706.4 512.2" />
                        <line
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            x1="698.2"
                            y1="512.2"
                            x2="587.4"
                            y2="512.2" />
                        <line
                            class="h-line-miter fill-none stroke-woom-red stroke-3"
                            x1="583.3"
                            y1="512.2"
                            x2="579.3"
                            y2="512.2" />
                    </g>
                </g>
                <g>
                    <path
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        d="M654.9,512.3c0-1.3,0-2.7.2-4" />
                    <path
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        d="M656.7,499c3.1-10.8,9.8-20.1,18.8-26.4" />
                    <path
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        d="M679.6,470.2c1.2-.7,2.3-1.3,3.6-1.8" />
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g>
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="527.6"
                    y1="133"
                    x2="291"
                    y2="133" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="526.4"
                    y="125.2"
                    width="2.4"
                    height="15.6" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="289.8"
                    y="125.2"
                    width="2.4"
                    height="15.6" />
            </g>
        </g>
        <g class="wheelbase hidden">
            <g>
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="634.4"
                    y1="363"
                    x2="168.3"
                    y2="363" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="633.2"
                    y="355.2"
                    width="2.4"
                    height="15.6" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="167.1"
                    y="355.2"
                    width="2.4"
                    height="15.6" />
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g id="geo-w2-G-F-seat-tube-angle">
                <polyline
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    points="308.1 223.2 395.1 512.3 164 512.3" />
            </g>
            <path
                class="h-line-miter fill-none stroke-woom-red stroke-3"
                d="M348.3,511.2c0-22.2,12.2-39.6,31.1-48.3" />
        </g>
        <g class="min-saddle-height hidden">
            <g id="line">
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="291"
                        y1="164.3"
                        x2="286.6"
                        y2="164.3" />
                    <line
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        x1="277.7"
                        y1="164.3"
                        x2="32"
                        y2="164.3" />
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="27.6"
                        y1="164.3"
                        x2="23.1"
                        y2="164.3" />
                </g>
                <g id="w2-min-saddle-height">
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="10"
                            y1="164.3"
                            x2="10"
                            y2="512.3" />
                        <rect
                            class="fill-woom-red stroke-woom-red"
                            x="2.2"
                            y="163.1"
                            width="15.6"
                            height="2.4" />
                        <rect
                            class="fill-woom-red stroke-woom-red"
                            x="2.2"
                            y="511.1"
                            width="15.6"
                            height="2.4" />
                    </g>
                </g>
            </g>
            <g id="saddle">
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="310.2"
                    y1="209.3"
                    x2="303.7"
                    y2="189.7" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="298.7"
                    y1="212.6"
                    x2="292.5"
                    y2="192" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M254.6,163.4s81.2,2.6,89.3,2.6,14.3,5.4,12.8,8.7-5.1,2-9.4,1.9-20.5-2.5-35.7,2.4c-15.1,4.9-20.3,11.5-34.8,11s-26.1-7.8-28.8-14c-2.7-6.2-1.3-12.2,6.6-12.6Z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M279.4,190.7s1.4,2.2,5.9,1.6c4.5-.6,20.3-2.3,26-4.6,5.6-2.3,18.3-11.4,18.3-11.4" />
            </g>
        </g>
        <g class="max-saddle-height hidden">
            <g
                id="line-2"
                data-name="line">
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="10"
                        y1="125.5"
                        x2="10"
                        y2="512.3" />
                    <rect
                        class="fill-woom-red stroke-woom-red"
                        x="2.2"
                        y="124.3"
                        width="15.6"
                        height="2.4" />
                    <rect
                        class="fill-woom-red stroke-woom-red"
                        x="2.2"
                        y="511.1"
                        width="15.6"
                        height="2.4" />
                </g>
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="291"
                        y1="125.5"
                        x2="286.4"
                        y2="125.5" />
                    <line
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        x1="276.8"
                        y1="125.5"
                        x2="32.6"
                        y2="125.5" />
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="27.8"
                        y1="125.5"
                        x2="23.1"
                        y2="125.5" />
                </g>
            </g>
            <g
                id="saddle-2"
                data-name="saddle">
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="310.2"
                    y1="209.3"
                    x2="291.7"
                    y2="149.7" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="298.7"
                    y1="212.6"
                    x2="280.5"
                    y2="152" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M242.6,123.4s81.2,2.6,89.3,2.6,14.3,5.4,12.8,8.7-5.1,2-9.4,1.9-20.5-2.5-35.7,2.4c-15.1,4.9-20.3,11.5-34.8,11s-26.1-7.8-28.8-14c-2.7-6.2-1.3-12.2,6.6-12.6Z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M267.4,150.7s1.4,2.2,5.9,1.6c4.5-.6,20.3-2.3,26-4.6,5.6-2.3,18.3-11.4,18.3-11.4" />
            </g>
        </g>
        <g class="crank-length hidden">
            <g>
                <line
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    x1="361.1"
                    y1="395.6"
                    x2="409.9"
                    y2="443.6" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="353.3"
                    y="394.4"
                    width="15.6"
                    height="2.4"
                    transform="translate(-174.2 376.1) rotate(-45.5)" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="402.1"
                    y="442.4"
                    width="15.6"
                    height="2.4"
                    transform="translate(-193.8 425.3) rotate(-45.5)" />
            </g>
        </g>
        <g class="handlebar-adjustability hidden">
            <g
                id="line-3"
                data-name="line">
                <g>
                    <path
                        class="h-line fill-none stroke-woom-red stroke-3"
                        d="M534.9,37.6c23.4,2.1,42,20.7,44.1,44.1" />
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="536.2 43.7 526.4 36.8 537.2 31.8 536.2 43.7" />
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="572.9 80.5 579.8 90.3 584.8 79.4 572.9 80.5" />
                </g>
            </g>
            <path
                id="handlebar"
                class="fill-none stroke-woom-black stroke-2"
                d="M520.7,144.2l-3.9-8.6,1.4-4.9,24-17.2M553.1,122.5s-10.9,7.9-14.3,10.5c-3.3,2.6-2.2,5.2-2.2,5.2M537.3,101.7s-.3.5-.7,1.5c9,5.5,5.4,15.5,5.4,15.5l-3.1,1.2,1.4,3.8s6.6.6,10.4,0c3.7-.7,7-5.9,4.1-9.7s-4.7-5.8-6.4-14.2M546.3,72.3c-4.2-4.2-11.1-4.3-15.4,0s-4.3,11.1,0,15.4c3.2,3.2,7.9,4,11.8,2.4,1.3-.5,2.5-1.3,3.6-2.4,4.2-4.2,4.2-11.1,0-15.4ZM541.1,90.6s.7-.8-2.9,2.8c-3.7,3.6-1.7,7.4,0,9,1.6,1.6,5.4,2,7.2.2s4.2-4.8,7.5-9.1c3.3-4.3-.7-7.5-3.4-10.3M552.7,86c.7-5-3.3-6.9-3.3-6.9M552,114.4c-1.4-1.4-3.8-1.4-5.2,0s-1.4,3.8,0,5.2,3.8,1.4,5.2,0,1.4-3.7,0-5.2Z" />
        </g>
        <g class="stand-over-height hidden">
            <g>
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="10"
                    y1="213"
                    x2="10"
                    y2="512.3" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="2.2"
                    y="211.8"
                    width="15.6"
                    height="2.4" />
                <rect
                    class="fill-woom-red stroke-woom-red"
                    x="2.2"
                    y="511.1"
                    width="15.6"
                    height="2.4" />
            </g>
            <g
                id="line-4"
                data-name="line">
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="405.5"
                        y1="212.9"
                        x2="400.8"
                        y2="212.9" />
                    <line
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        x1="391.2"
                        y1="212.9"
                        x2="32.4"
                        y2="212.9" />
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="27.6"
                        y1="212.9"
                        x2="22.9"
                        y2="212.9" />
                </g>
            </g>
        </g>
    </svg>
</template>
